module.exports = function() {

  return function(customers, filter) {
    return customers.filter(function(customer) {
      return (! filter.routeId || customer.routeId === +filter.routeId) &&
             customer.filterDeliveries(filter.status, filter.delayed).length;
    });
  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/filters/fleetCustomers.js
 ** module id = 163
 ** module chunks = 1
 **/